import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { BookOpen, ArrowRight } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";

export default function Conseils() {
  const { data: articles = [], isLoading } = useQuery({
    queryKey: ["kb"],
    queryFn: async () => (await api.get("/kb")).data,
  });
  return (
    <PublicLayout>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D9BF0]">Base de connaissances</p>
        <h1 className="mt-2 text-4xl font-extrabold text-[#263871] sm:text-5xl">Conseils & entretien</h1>
        <p className="mt-4 max-w-xl text-lg text-slate-600">Tout savoir pour utiliser et entretenir votre climatisation comme un pro.</p>
        {isLoading ? (
          <p className="mt-12 text-slate-500">Chargement…</p>
        ) : (
          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {articles.map((a) => (
              <Link key={a.slug} to={`/conseils/${a.slug}`} data-testid={`kb-card-${a.slug}`} className="group flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg">
                <div className="rounded-xl bg-[#E0F2FE] p-3"><BookOpen className="h-6 w-6 text-[#1D9BF0]" /></div>
                <div className="flex-1">
                  <span className="text-xs font-semibold uppercase tracking-wide text-slate-400">{a.category}</span>
                  <h3 className="mt-1 text-lg font-bold text-[#263871]">{a.title}</h3>
                  <span className="mt-3 flex items-center gap-1 text-sm font-semibold text-[#263871] group-hover:gap-2 transition-all">Lire <ArrowRight className="h-4 w-4" /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
